import { AppItem } from '../../../AppsList/AppItem'
import { FC, useEffect } from 'react'
import { useCurrentUser } from '@wellesley/user'
import { useLazyGetApiV1GroupsByGroupIdAppsQuery } from '@wellesley/apps'
import { SideBarTitle } from '../../../../../common/components/side-bar/SideBarTitle'

type GroupAppsProps = {
  groupId: string
  groupName: string
}
export const GroupApps: FC<GroupAppsProps> = ({ groupId, groupName }) => {
  const { user } = useCurrentUser()

  const [getGroupApps, { data: appsList = [] }] =
    useLazyGetApiV1GroupsByGroupIdAppsQuery({})

  useEffect(() => {
    void getGroupApps({ groupId }, true).unwrap()
  }, [groupId])

  if (!appsList) return null

  return (
    <>
      <SideBarTitle title="Group apps" />
      {appsList.map((app) => (
        <AppItem
          key={app.id}
          app={app}
          entryPoint="GROUP"
          size="lg"
          username={user?.username}
          groupname={groupName}
        />
      ))}
    </>
  )
}
